import { ref } from "@nuxtjs/composition-api";
import { defineStore } from "pinia";

import useSearchAssistanceServiceApi from "./-api";

interface SearchAssistanceStoreContext {
  $api: ReturnType<typeof useSearchAssistanceServiceApi>;
}

export const useSearchAssistanceStore = defineStore(
  "search-assistance",
  () => {
    // State
    const autocompleteResults = ref<SearchAutocompleteSuggestion[]>([]);

    // Actions
    async function fetchAutocompleteResults(this: SearchAssistanceStoreContext, params: PostSearchAutocompleteRequest) {
      const response = await this.$api.fetchAutocompleteResults(params);
      autocompleteResults.value = response.data.suggestions;
    }

    function resetStore() {
      autocompleteResults.value = [];
    }

    return {
      autocompleteResults,
      fetchAutocompleteResults,
      resetStore,
    };
  },
  {
    api: useSearchAssistanceServiceApi,
  },
);
